import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  radioAnatomy.keys
);

const baseStyle = definePartsStyle({
  control: {
    _checked: {
      bg: "brand.analytic",
      borderColor: "brand.analytic",
    },
  },
});

export const radioTheme = defineMultiStyleConfig({ baseStyle });
